export default "__VITE_ASSET__DcCL_75F__"